import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Counter = styled.span`
  position: absolute;
  right: 0.25rem;
  top: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  min-width: 2rem;
  color: ${({ theme }) => theme.colors.primary.white};
  font-size: 10px;
  text-align: right;
  background-color: ${({ theme }) => theme.colors.primary.blueDark};
  padding: 4px 8px;
  border: 2px solid ${({ theme }) => theme.colors.primary.white};
  border-radius: 8px;
`;
